<template>
  <v-container id="contact-grid" grid-list-xl>
    <section class="ftco-section">
      <div class="row justify-content-center">
        <div class="col-md-6 col-lg-6">
          <div class="d-md-flex">
            <v-card class="px-4">
              <v-card-title class="w-100 card-title mb-2">
                {{ $t("reset_title") }}
              </v-card-title>
              <v-card-title class="w-100 card-title mb-2 justify-center">
                <div
                  v-if="errors['connexion']"
                  class="text-danger text-sm-body-2"
                >
                  <span>{{ errors["connexion"][langLocal] }}</span>
                </div>
              </v-card-title>
              <v-card-text>
                <v-snackbar
                  v-model="snackbar"
                  :color="snackbarColor"
                  :timeout="4000"
                  :top="true"
                  style="z-index: 1500"
                >
                  {{ snackbar_text }}
                </v-snackbar>
                <v-form class="mb-5">
                  <v-row>
                    <v-col cols="12">
                      <v-text-field
                        v-model="password"
                        :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                        :error-messages="passwordErrors"
                        @blur="$v.password.$touch()"
                        :type="show1 ? 'text' : 'password'"
                        name="lastname"
                        :label="$t('new_password')"
                        :hint="$t('minCaracter')"
                        counter
                        @click:append="show1 = !show1"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        block
                        v-model="verify"
                        :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                        :type="show1 ? 'text' : 'password'"
                        name="passwordconfirm"
                        :label="$t('password_confirm')"
                        counter
                        @click:append="show1 = !show1"
                        :error-messages="verifyErrors"
                        @blur="$v.verify.$touch()"
                      ></v-text-field>
                    </v-col>
                    <v-btn
                      class="mx-2 my-2"
                      color="warning"
                      @click="submit"
                      :loading="isLoading"
                      :disabled="this.$v.$invalid"
                    >
                      {{ $t("reset_btn") }}
                    </v-btn>
                  </v-row>
                </v-form>
              </v-card-text>
            </v-card>
          </div>
        </div>
      </div>
    </section>
  </v-container>
</template>

<script>
import img from "../../public/african.jpeg";
import { validationMixin } from "vuelidate";
import { mapGetters } from "vuex";
import {
  required,
  maxLength,
  minLength,
  sameAs,
} from "vuelidate/lib/validators";

export default {
  name: "Register",
  mixins: [validationMixin],
  validations: {
    password: { required, minLength: minLength(8), maxLength: maxLength(16) },
    verify: {
      required,
      sameAs: sameAs(function () {
        return this.password;
      }),
    },
  },
  created() {
    this.$store.dispatch("setCurrentRoute", this.$route.name);
    const urlParams = new URLSearchParams(window.location.search);
    this.id = urlParams.get("q");
    this.token = urlParams.get("token");
    if (!this.id || !this.token) {
      this.$router.push({
        name: "login",
      });
    }
  },
  data() {
    return {
      snackbar: false,
      snackbarColor: "default",
      snackbar_text: "",
      id: null,
      token: null,
      checkbox: null,
      isLoading: false,
      show1: false,
      img_log: img,
      password: "",
      verify: "",
    };
  },
  watch: {
    show(value, oldvalue) {
      setTimeout(() => {
        this.show = false;
      }, 2000);
    },
  },
  methods: {
    sleep(ms) {
      return new Promise((resolve) => {
        setTimeout(resolve, ms);
      });
    },
    async submit() {
      this.isLoading = true;
      this.$v.$touch();
      const data = new FormData();
      data.append("id", this.id);
      data.append("token", this.token);
      data.append("password", this.password);
      data.append("password_confirmation", this.verify);

      console.log();
      if (!this.$v.$invalid) {
        await this.$store
          .dispatch("resetPassword", data)
          .then((response) => {
            this.isLoading = false;

            console.log(response);

            if (response.data == "Not found") {
              this.snackbar = true;
              this.snackbarColor = "red";
              this.snackbar_text = this.getLocaleMessages["updatepwd_failed"];
            } else {
              this.snackbar = true;
              this.snackbarColor = "green";
              this.snackbar_text = this.getLocaleMessages["updatepwd_success"];

              this.sleep(10000);
              this.$router
                .push({
                  name: "login",
                })
                .catch(() => {});
            }
          })
          .catch((error) => {
            this.loading = false;
            console.error(error);
          });
      }
    },
  },
  beforeCreate() {
    this.isLoading = false;
    this.$store.dispatch("clear");
  },
  computed: {
    getLocaleMessages() {
      return this.$root.$i18n.messages[this.$root.$i18n.locale];
    },
    verifyErrors() {
      const errors = [];
      if (!this.$v.verify.$dirty) return errors;
      !this.$v.verify.required &&
        errors.push(this.getLocaleMessages["required_confirm_password"]);
      if (this.password != this.verify)
        errors.push(this.getLocaleMessages["match_password"]);
      return errors;
    },
    passwordErrors() {
      const errors = [];
      if (!this.$v.password.$dirty) return errors;
      if (!this.$v.password.minLength)
        errors.push(this.getLocaleMessages["min_password"]);
      !this.$v.password.required &&
        errors.push(this.getLocaleMessages["required_password"]);
      return errors;
    },

    ...mapGetters([
      "current_route",
      "registered",
      "loading",
      "errors",
      "langLocal",
    ]),
  },
};
</script>

<style scoped>
@import "../../public/assets/css/style.css";


.v-card__title {
    word-break: unset !important;
}

#contact-grid {
  width: 100%;
}
#img-block {
  background-image: url("../../public/african.jpeg");
}
.mobile-position {
  margin: 10px;
}
.card-title {
  color: rgb(63, 53, 99);
  font-family: Verdana, Geneva, Tahoma, sans-serif;
}
.w3l-footer {
  position: fixed;
  left: 0px;
  bottom: 0px;
  z-index: 100;
  width: 100%;
}

@media (max-width: 700px) {
  #img-block {
    display: none;
  }
  .login-wrap {
    min-height: 60vh;
  }
}
</style>
